import styled from 'styled-components';

export const LogoWrapper = styled.img`
  height: 2rem;
`;
